import React from "react";
import { getReportTypeLabel } from "../reportTypes";

function SwatchList({ items, limit = 6 }) {
  const list = Array.isArray(items) ? items.slice(0, limit) : [];
  if (list.length === 0) return <div className="report-preview-muted">Bez legendy</div>;
  return (
    <div className="report-preview-legend">
      {list.map((item, index) => (
        <div key={`${item.label || item.color}-${index}`} className="report-preview-legend-row">
          <span className="report-preview-swatch" style={{ background: item.color || "#cbd5e1" }} />
          <span>{item.label || "Třída"}</span>
        </div>
      ))}
    </div>
  );
}

function MapPreviewBody({ item }) {
  const snapshot = item.snapshot || {};
  const legend = snapshot.legend || [];
  const viewport = snapshot.viewport || {};
  const isLandscape = item.orientation === "landscape";
  return (
    <div className={`report-preview-map-layout ${isLandscape ? "is-landscape" : "is-portrait"}`}>
      <div className="report-preview-map">
        <div className="report-preview-map-grid" />
        <div className="report-preview-map-shape one" />
        <div className="report-preview-map-shape two" />
        <div className="report-preview-map-shape three" />
        <div className="report-preview-map-label">
          {viewport.zoom ? `zoom ${viewport.zoom}` : "uložený výřez"}
        </div>
      </div>
      <div className="report-preview-side">
        <div className="report-preview-kicker">{snapshot.electionLabel || snapshot.electionId || "Volby"}</div>
        <div className="report-preview-focus">{snapshot.partyLabel || snapshot.selectedEntity || snapshot.rankLabel || "Výběr"}</div>
        <SwatchList items={legend} />
      </div>
    </div>
  );
}

function LandmarkPreviewBody({ item }) {
  const snapshot = item.snapshot || {};
  const enabledLayers = snapshot.enabledLayers || {};
  const activeLayers = Object.keys(enabledLayers).filter((key) => enabledLayers[key]);
  const isNeutral = snapshot.neutralMode === true || snapshot.electionMode === "none";
  const selectedCount = Number(snapshot.selectedSummary?.count ?? snapshot.selectedPrecinctRows?.length ?? 0);
  return (
    <div className="report-preview-map-layout is-landscape">
      <div className="report-preview-side">
        <div className="report-preview-kicker">{snapshot.electionLabel || snapshot.electionId || "Volby"}</div>
        <div className="report-preview-focus">{isNeutral ? `${selectedCount} vybraných okrsků` : snapshot.partyLabel || "Výběr"}</div>
        <div className="report-preview-chip-row">
          {(activeLayers.length ? activeLayers : ["bez vrstvy"]).map((layer) => (
            <span key={layer} className="report-preview-chip">{layer}</span>
          ))}
        </div>
        {isNeutral ? <div className="report-preview-muted">2 stránky: mapa + data</div> : <SwatchList items={snapshot.legend} limit={4} />}
      </div>
      <div className="report-preview-map">
        <div className="report-preview-map-grid" />
        <div className="report-preview-map-shape one" />
        <div className="report-preview-map-shape two" />
        <div className="report-preview-map-shape three" />
      </div>
    </div>
  );
}

export default function ReportPreview({ item, mode = "thumbnail" }) {
  if (!item) return null;
  const body =
    item.type === "landmarks_map" ? <LandmarkPreviewBody item={item} /> : <MapPreviewBody item={item} />;
  return (
    <div className={`report-preview report-preview-${mode} is-${item.orientation}`}>
      <div className="report-preview-page">
        <div className="report-preview-header">
          <div>
            <div className="report-preview-type">{getReportTypeLabel(item.type)}</div>
            <div className="report-preview-title">{item.title || "Report"}</div>
          </div>
          <div className="report-preview-orientation">{item.orientation === "landscape" ? "A4 landscape" : "A4 portrait"}</div>
        </div>
        {body}
        {item.note ? <div className="report-preview-note">{item.note}</div> : null}
      </div>
    </div>
  );
}
